<!-- INFORMASI RETAILER -->
<app-card-detail-body
  [loading]="isLoading"
  [title]="'Informasi Retailer'"
  [bodyList]="detailRetailerInfo"
  [cardClasses]="'p-8'"
  [cardHeaderClasses]="!isLoading.value ? 'pb-0' : ''"
></app-card-detail-body>

<!-- CAKUPAN WILAYAH -->
<app-card [header]="true" [cardHeaderTitle]="'Cakupan Wilayah'" [cardClasses]="'my-8 p-8'" [cardHeaderClasses]="'pb-0'">
  <ng-container cardBody>
    <app-skeleton-text [type]="'text-and-text'" [fluidSize]="true" [isLoading]="isLoading">
      <app-input-listbox-cakupan-wilayah (selectionOutput)="handleOutputChips($event)"></app-input-listbox-cakupan-wilayah>
    </app-skeleton-text>
  </ng-container>
</app-card>

<!-- DOKUMEN -->
<app-card [header]="true" [cardHeaderTitle]="'Dokumen'" [cardClasses]="'p-8'" [cardHeaderClasses]="'pb-0'">
  <ng-container cardBody>
    <form [formGroup]="formRegisterMAC">
      <app-skeleton-text [type]="'text-and-text'" [fluidSize]="true" [isLoading]="isLoading">
        <app-input-text
          [pattern]="'^[0-9.\\-]*$'"
          [required]="true"
          [placeholder]="'Silahkan input nomor NPWP'"
          label="NPWP"
          formControlName="npwp"
          ngDefaultControl
        ></app-input-text>
      </app-skeleton-text>

      <app-skeleton-text [type]="'text-and-text'" [fluidSize]="true" [isLoading]="isLoading">
        <app-image-upload
          *ngIf="(isLoading | async) === false"
          [style]="'Theme1'"
          [label]="'Dokumen NPWP'"
          [data]="getNpwpImage()"
          [enableDelete]="!retailerIsR1()"
          (urlOutput)="handleImageUrl($event)"
          formControlName="npwp_image_url"
          ngDefaultControl
        ></app-image-upload>
      </app-skeleton-text>
    </form>
  </ng-container>
</app-card>

<!-- BUTTON GROUP -->
<div class="d-flex justify-content-between align-items-center mt-7">
  <button class="btn btn-outline btn-outline-gray" type="button" (click)="handleCancel()">
    <span class="text-primary">Batal</span>
  </button>
  <button class="btn btn-primary ms-4" type="submit" (click)="handleSubmit()" [disabled]="!isValidForms()">
    <span>Setujui</span>
  </button>
</div>

<app-modal-confirm-register #modalConfirmRegister></app-modal-confirm-register>
